<template>
  <div v-if="!executing && userDetails.timezone">
    <mdb-input label="Title" :placeholder="capitalize($tc('common.label.event',1)) + ' Title'"
               type="text" v-model="summary.title"/>
    <mdb-input label="Public Title" placeholder="A different title for non-members. Optional."
               type="text" v-model="summary.publicTitle"/>
    <div class="md-form">
      <div>
        <date-picker
          type="datetime"
          :format="userDetails.dateFormat.toUpperCase() + ' ' + (userDetails.timeFormat=='AM/PM' ? 'hh:mm a' : 'HH:mm')"
          value-type="date"
          editable
          :clearable="false"
          :lang="lang"
          v-model="summary.startDate"
          confirm
        />
        <label class="active mr-5">Start Date</label>
      </div>
    </div>
    <div class="md-form">
      <div>
        <date-picker
          type="datetime"
          :format="userDetails.dateFormat.toUpperCase() + ' ' + (userDetails.timeFormat=='AM/PM' ? 'hh:mm a' : 'HH:mm')"
          value-type="date"
          editable
          :clearable="false"
          :lang="lang"
          v-model="summary.endDate"
          confirm
        />

        <label class="active mr-5">End Date</label>
      </div>
    </div>
    <div class="md-form" v-if="eventSpansDays">
      <input aria-label="Every Day" class="form-control form-check-input" id="every-day" type="checkbox"
             v-model="everyDay"/>
      <label class="active mr-5" for="every-day">{{capitalize($tc('common.label.event',1))}} is Every Day in Range</label>
    </div>
    <div class="md-form" v-if="eventSpansDays && !everyDay">
      <label class="active mr-5">Days</label>
      <input aria-label="Monday" class="form-control form-check-input" id="monday" type="checkbox"
             v-model="monday"/>
      <label class="mr-4" for="monday">Monday</label>
      <input aria-label="Tuesday" class="form-control form-check-input" id="tuesday" type="checkbox"
             v-model="tuesday"/>
      <label class="mr-4" for="tuesday">Tuesday</label>
      <input aria-label="Wendesday" class="form-control form-check-input" id="wednesday" type="checkbox"
             v-model="wednesday"/>
      <label class="mr-4" for="wednesday">Wednesday</label>
      <input aria-label="Thursday" class="form-control form-check-input" id="thursday" type="checkbox"
             v-model="thursday"/>
      <label class="mr-4" for="thursday">Thursday</label>
      <input aria-label="Friday" class="form-control form-check-input" id="friday" type="checkbox"
             v-model="friday"/>
      <label class="mr-4" for="friday">Friday</label>
    </div>
    <div class="md-form" v-if="eventSpansDays && !everyDay">
      <input aria-label="Saturday" class="form-control form-check-input" id="saturday" type="checkbox"
             v-model="saturday"/>
      <label class="mr-4" for="saturday">Saturday</label>
      <input aria-label="Sunday" class="form-control form-check-input" id="sunday" type="checkbox"
             v-model="sunday"/>
      <label class="mr-4" for="sunday">Sunday</label>
    </div>
    <div class="form-check">
      <mdb-tooltip :options="{placement: 'left'}" trigger="hover">
        <span slot="tip">Although an end date and time is required for {{$tc('common.label.event',2)}}, you can elect not to
          display this to {{$tc('common.label.member',2)}}.
        </span>
        <mdb-icon icon="info-circle" slot="reference"/>
      </mdb-tooltip>
      <div>
        <input aria-label="Hide end time" class="form-control form-check-input" id="hideEndTime" type="checkbox"
               v-model="summary.hideEndTime"/>
        <label for="hideEndTime">Hide End Time?</label>
      </div>
      <div v-if="showHostOption">
        <input aria-label="Set me as host" class="form-control form-check-input" id="setAsHost" type="checkbox"
               v-model="summary.setAsHost"/>
        <label for="setAsHost">Set me as {{$tc('common.label.host',1)}}</label>
      </div>
    </div>

    <div>
      <mdb-btn :disabled="!(summary.title && summary.startDate && summary.endDate)" @click="doSave" color="success"
               icon="save">
        Save
      </mdb-btn>
      <mdb-btn @click="doCancel" color="danger" icon="times-circle" v-if="!hideCancel">Cancel</mdb-btn>
    </div>

    <div v-if="showSeriesModal">
      <series-modal @closeModal="showSeriesModal=false" @seriesChoice="setSeriesChoice"/>
    </div>

  </div>

</template>

<script>
import SeriesModal from "./SeriesModal";
import api from '../../services/groupsPlaceApi.js'
import {Datetime} from 'vue-datetime'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import 'vue2-datepicker/index.css';
import {
  mdbBtn,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip
} from 'mdbvue';

export default {
  name: 'Event-Summary-Editor',
  components: {
    mdbBtn,
    mdbContainer,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbTooltip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    Datetime,
    SeriesModal,
    DatePicker
  },
  props: {
    summary: {
      type: Object,
      default: null
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    showHostOption: {
      type: Boolean,
      default: false
    }

  },
  //computed: mapState({userDetails: state => state.userDetails}),
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
    group() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    },
    startDate() {
      return this.summary.startDate
    },
    eventSpansDays() {
      if (!this.summary.startDate || !this.summary.endDate) return false
      let start = moment(this.summary.startDate).format("YYYYMMDD")
      let end = moment(this.summary.endDate).format("YYYYMMDD")
      return start != end
    }
  },
  data() {
    return {
      showSeriesModal: false,
      seriesChoice: null,
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      everyDay: true,
      lang: {
        formatLocale: {
          firstDayOfWeek: 0
        }
      }
    }
  },
  mounted() {
    if (this.userDetails && this.userDetails.firstDayOfWeek == "Monday") this.lang.formatLocale.firstDayOfWeek = 1;
    if (!this.summary.rangeDays || this.summary.rangeDays.length == 0) {
      this.everyDay = true;
      return
    }
    this.everyDay = false
    for (let i = 0; i < this.summary.rangeDays.length; i++) {
      let day = this.summary.rangeDays[i];
      if (day == 0) this.sunday = true
      if (day == 1) this.monday = true
      if (day == 2) this.tuesday = true
      if (day == 3) this.wednesday = true
      if (day == 4) this.thursday = true
      if (day == 5) this.friday = true
      if (day == 6) this.saturday = true
    }
  },
  watch: {
    startDate: function (newDate, oldDate) {
      if (newDate && !this.summary.endDate) {
        this.summary.endDate = moment(this.summary.startDate).add(2, 'h').toDate()
      }
      if (newDate && this.summary.endDate) {
        let oldDiff = this.summary.endDate - oldDate
        this.summary.endDate = moment(this.summary.startDate).add(oldDiff).toDate()
      }

    },
    sunday: function (n, o) {
      this.updateDays();
    },
    monday: function (n, o) {
      this.updateDays();
    },
    tuesday: function (n, o) {
      this.updateDays();
    },
    wednesday: function (n, o) {
      this.updateDays();
    },
    thursday: function (n, o) {
      this.updateDays();
    },
    friday: function (n, o) {
      this.updateDays();
    },
    saturday: function (n, o) {
      this.updateDays();
    },
    everyDay: function (n) {
      if (n) {
        this.monday = false
        this.tuesday = false
        this.wednesday = false
        this.thursday = false
        this.friday = false
        this.saturday = false
        this.sunday = false

      }

    }
  },
  methods: {
    setSeriesChoice(choice) {
      this.seriesChoice = choice
      this.doSave()
    },
    updateDays() {
      this.summary.rangeDays = []
      if (this.sunday) this.summary.rangeDays.push(0)
      if (this.monday) this.summary.rangeDays.push(1)
      if (this.tuesday) this.summary.rangeDays.push(2)
      if (this.wednesday) this.summary.rangeDays.push(3)
      if (this.thursday) this.summary.rangeDays.push(4)
      if (this.friday) this.summary.rangeDays.push(5)
      if (this.saturday) this.summary.rangeDays.push(6)
      console.log(this.summary.rangeDays)
    },
    doSave() {
      if (this.summary.repeats && !this.seriesChoice && this.summary.status != "Draft") {
        this.showSeriesModal = true
        return
      }
      this.$store.dispatch("setExecuting", true);
      let url = '/event/summary/' + this.summary.id
      if (this.summary.id == "new") url = '/event/create/' + this.group.vanityPath
      if (this.summary.repeats && this.seriesChoice) this.summary.series = this.seriesChoice
      api.post(url, this.summary).then(
        (results) => {
          this.$emit("saveSummary", results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
        this.showSeriesModal = false
        this.seriesChoice = null
      })
    },
    doCancel() {
      this.$emit("cancelSummary")
    }
  }
}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
